import React from "react";

/**
 * Metalotsen Logo — verwendet die hochgeladene Originalgrafik
 * (transparente PNG-Version des M-Icons).
 *
 * Zum Austauschen einfach `/uploads/metalotsen-icon.png` ersetzen.
 */
export function Logo({ className = "h-8 w-8", light = false }) {
  return (
    <img
      src="/uploads/metalotsen-icon.png"
      alt="Metalotsen Logo"
      className={`${className} object-contain select-none`}
      draggable={false}
      width={64}
      height={64}
      // Prevent CLS by reserving space
      style={{ aspectRatio: "1 / 1" }}
      // The image itself is on transparent BG so it works on both dark and light nav.
      // On very-light backgrounds we could tint via filter, but the M-blue reads
      // beautifully on both #0F172A and #FFFFFF.
    />
  );
}

/**
 * MetalotsenWordmark — komplettes Logo inkl. Wortmarke „METALOTSEN"
 * und Claim „DIGITALE LÖSUNGEN. KLARER KURS". Nützlich für die
 * Footer-Signatur oder als „About the brand"-Element.
 */
export function MetalotsenWordmark({ className = "h-16" }) {
  return (
    <img
      src="/uploads/metalotsen-logo-full.png"
      alt="Metalotsen — Digitale Lösungen. Klarer Kurs."
      className={`${className} object-contain select-none`}
      draggable={false}
      loading="lazy"
      decoding="async"
    />
  );
}
